// extracted by mini-css-extract-plugin
export var columnList = "_dc-0";